function HistoryState(prev, meta) {
  this.undo = "";
  this.redo = "";
  this.prev = prev;
  this.next = null;
  if(prev) prev.next = this;
  this.onchange = null;
  this.meta = meta || {};
}

function History() {
  this.clear();
}

History.prototype.hasUndo = function() { return !!this.state.prev; };
History.prototype.hasRedo = function() { return !!this.state.next; };

History.prototype.commitUndo = function(redoURL) {
  const prev = this.state.prev;
  if(!prev) return;
  if(!this.state.redo) this.state.redo = redoURL;
  this.state = prev;
  if(this.onchange) this.onchange();
};

History.prototype.commitRedo = function() {
  const next = this.state.next;
  if(!next) return;
  this.state = next;
  if(this.onchange) this.onchange();
};

History.prototype.getRedoURL = function() {
  const next = this.state.next;
  return next && next.redo;
};

History.prototype.getUndoURL = function() {
  return this.state.undo;
};

History.prototype.push = function(undoURL, meta) {
  this.state = new HistoryState(this.state, meta);
  if(undoURL) this.state.undo = undoURL;
  if(this.onchange) this.onchange();
  return this.state;
};

History.prototype.clear = function() {
  this.state = new HistoryState(null, "none", "");
  if(this.onchange) this.onchange();
};

export default History;
